import React from 'react';
import SvgIcon from './SvgIcon';

const More = props => (
    <SvgIcon viewBox="0 0 24 26" {...props}>
        <path
            d="M15 22a3 3 0 10-6 0 3 3 0 006 0zM15 4a3 3 0 10-6 0 3 3 0 006 0zM15 13a3 3 0 10-6 0 3 3 0 006 0z"
            stroke="currentColor"
        />
    </SvgIcon>
);

More.displayName = 'MoreIcon';

export default More;
